/*
 * practitioner (schema)
 */
import { boolean, integer, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"

export const practitioners = schema.table("practitioners", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	userId: uuid("user_id").references(() => users.id, { onDelete: "set null" }),

	// --- Name ---
	firstName: varchar("first_name", { length: 128 }).notNull(),
	middleName: varchar("middle_name", { length: 128 }),
	lastName: varchar("last_name", { length: 128 }).notNull(),

	// --- Clinic ---
	clinicName: varchar("clinic_name", { length: 256 }),

	// --- Contact ---
	email: varchar("email", { length: 256 }),
	phone: varchar("phone", { length: 32 }),
	phone2: varchar("phone2", { length: 32 }),
	fax: varchar("fax", { length: 32 }),
	website: varchar("website", { length: 256 }),

	// --- Signature ---
	signatureData: text("signature_data"),  // base64 data URL (PNG)

	// --- Professional ---
	professionalDesignation: varchar("professional_designation", { length: 64 }),
	specialization: varchar("specialization", { length: 128 }),
	licenseNumber: varchar("license_number", { length: 64 }),
	biography: text("biography"),
	defaultAppointmentMinutes: integer("default_appointment_minutes"),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true })
		.notNull()
		.defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true })
		.notNull()
		.defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, {
		onDelete: "set null",
	}),
	updatedBy: uuid("updated_by").references(() => users.id, {
		onDelete: "set null",
	}),
})
